import React, { useState, useEffect } from "react";
import "./single.css";
import Navbar from "../../navbar/Navbar";
import Footer from "../../footer/footer";
import { DiscussionEmbed } from "disqus-react";

function SingleActivity({ match }) {
  const [item, setItem] = useState({});

  useEffect(() => {
    window.scrollTo(0,0);
  },[]);

  useEffect(() => {
    fetch(`https://tranquil-lake-34438.herokuapp.com/activities/${match.params.id}`)
      .then((foundItem) => {
        if (foundItem.ok) {
          return foundItem.json();
        }
      })
      .then((foundItem) => setItem(foundItem));
    // eslint-disable-next-line
  }, [item]);

  return (
    <div>
      <Navbar />
      <div className="act-bg">
        <h1>{item.title}</h1>
        <p className="title_p">{item.shortDescription}</p>
        <div className="single_post">
          <img src={item.imageUrl} alt="" />
        </div>
        <div className="para_b">
          <p>{item.paragraphOne}</p>
        </div>
        <div className="para_b">
          <p>{item.paragraphTwo}</p>
        </div>
        <div className="para_b">
          <p>{item.paragraphThree}</p>
        </div>
        <div className="comment_section">
          <DiscussionEmbed
            shortname="the-fidel-foundation"
            config={{
              url: `http://localhost:3000/activities/${item._id}`,
              identifier: `${item._id}`,
              title: `${item.title}`,
              language: "en",
            }}
          />
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default SingleActivity;
